import { Input, useTheme, XStack, YStack, View } from '@ninjacart/nc-nk-ui';
import { Search } from '@tamagui/lucide-icons';
import { useTranslation } from 'react-i18next';

export function EdTechSearchComponent() {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <YStack width="100%" padding="$2"  testID='kisan_tId_edTechSearch'>
      <View position="relative" width="100%">
        <XStack position="absolute" left={16} top={20} transform={[{ translateY: -8 }]}>
          <Search color={theme['grey']?.val} size={22} />
        </XStack>
        <Input
          size="$5"
          width="100%"
          paddingLeft={48} // enough space for the icon
          borderWidth={1}
          backgroundColor="$inputBg"
          placeholder={t('page.search')}
          placeholderTextColor="$grey"
          borderColor="$grey"
          borderRadius={5}
          color="$usertextColor"
          keyboardType="web-search"
          editable={false}
          style={{ fontWeight: '500' }}
        />
      </View>
    </YStack>
  );
}
